import { render, staticRenderFns } from "./AllVendors.vue?vue&type=template&id=1fdc552e&scoped=true&"
import script from "./AllVendors.vue?vue&type=script&lang=js&"
export * from "./AllVendors.vue?vue&type=script&lang=js&"
import style0 from "./AllVendors.vue?vue&type=style&index=0&id=1fdc552e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc552e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdc552e')) {
      api.createRecord('1fdc552e', component.options)
    } else {
      api.reload('1fdc552e', component.options)
    }
    module.hot.accept("./AllVendors.vue?vue&type=template&id=1fdc552e&scoped=true&", function () {
      api.rerender('1fdc552e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/AllVendors.vue"
export default component.exports